// ═══ 업체 스코프 (ADMIN.md S2/S5) — '지금 어느 업체를 보고 있나' 의 단일 진실 ═══
// 서버 진실은 user.activeCompanyId 하나뿐이다 (POST /auth/switch-company 가 새 토큰 + user 를 준다).
// 새 API 없음. 화면은 이 훅만 읽고 **기존 쿼리 파라미터 그대로** 보낸다 — companyId=all(전체) / companyId=<id>.
//   admin: activeCompanyId > 0 → 그 업체 · 0 → 전체 (서버 utils/permissions.js getCompanyId 와 같은 규칙)
//   그 외: activeCompanyId || companyId (전체 모드 없음)
// 화면별 좌측 CompanyListPanel·현재/전체 토글·admin select 는 이 훅 + 헤더 모달로 대체됐다.
import { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

// 셸(Dashboard.js)이 듣는 이벤트 — 화면 어디서든 openPicker() 로 헤더 모달을 연다.
export var PICKER_EVENT = 'v2:open-company-picker';

export function isAdminRole(user) {
  return !!(user && (user.role === '관리자' || user.role === 'admin'));
}
// 업체를 넘나들 수 있는 계정. doc_agency 는 아직 v2 플래그가 안 켜지지만 규칙은 같다(소속 업체 안에서 전환).
export function canScopeUser(user) {
  return isAdminRole(user) || !!(user && user.role === 'doc_agency');
}

// /auth/my-companies 는 업체마다 차량 수를 세는 무거운 응답이다 —
// 셸 버튼 · 모달 · 화면들이 한 응답을 나눠 쓴다. 계정이 바뀌면(로그아웃 후 재로그인) uid 로 캐시를 버린다.
var _pending = null;
var _uid = -1;
export function loadCompanies(user) {
  var uid = (user && user.id) || 0;
  if (_pending && _uid === uid) return _pending;
  _uid = uid;
  _pending = authFetch(API + '/auth/my-companies').then(function (r) { return r.json(); })
    .then(function (d) { return (d && d.success && d.companies) || []; })
    .catch(function () { return []; });
  return _pending;
}
// 테스트/계정 전환용 캐시 무효화.
export function resetCompanies() { _pending = null; _uid = -1; }

export function useCompanies(user) {
  var st = useState([]); var list = st[0], setList = st[1];
  var uid = (user && user.id) || 0;
  useEffect(function () {
    var alive = true;
    loadCompanies(user).then(function (rows) { if (alive) setList(rows); });
    return function () { alive = false; };
  }, [uid]); // eslint-disable-line react-hooks/exhaustive-deps
  return list;
}

export function useCompanyScope(user) {
  var admin = isAdminRole(user);
  var scoped = canScopeUser(user);
  var companies = useCompanies(user);
  var companyId = admin
    ? ((user && user.activeCompanyId) || 0)
    : ((user && (user.activeCompanyId || user.companyId)) || 0);
  var allMode = admin && companyId === 0;
  var cur = companies.find(function (c) { return c.id === companyId; });
  return {
    isAdmin: admin,
    canScope: scoped,
    companyId: companyId,
    allMode: allMode,
    companyName: allMode ? '전체 업체' : (cur ? cur.name : ''),
    companies: companies,
    openPicker: function () {
      try { window.dispatchEvent(new CustomEvent(PICKER_EVENT)); } catch (e) { /* 구형 브라우저 */ }
    }
  };
}

export default useCompanyScope;
